import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import CssIcon from '../../../../basics/Icon/Icon.js';
import Button$1 from '../../../../basics/Button/Button.js';
import Typography$1 from '../../../../basics/Typography/Typography.js';
import StyledControls from './Controls.style.js';

const Controls = ({
  handleNext,
  handlePrevious,
  handleOverview,
  handleChange,
  handleClose,
  currentIndex,
  currentCaption,
  isOverview,
  numberOfBullets
}) => /*#__PURE__*/React$1.createElement(StyledControls, null, !isOverview && /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement(Button$1, {
  onClick: () => handleNext(),
  className: "controls__next",
  icon: "arrowRight"
}, "Next"), /*#__PURE__*/React$1.createElement(Button$1, {
  onClick: () => handlePrevious(),
  className: "controls__prev",
  icon: "arrowLeft",
  iconAlignment: "before"
}, "Prev")), /*#__PURE__*/React$1.createElement("div", {
  className: "controls__content"
}, /*#__PURE__*/React$1.createElement("button", {
  type: "button",
  onClick: handleOverview,
  className: "controls__close",
  "aria-label": isOverview ? 'Close 0verview' : 'Open Overview'
}, /*#__PURE__*/React$1.createElement("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, isOverview ? /*#__PURE__*/React$1.createElement("path", {
  d: "M26,32 L8,31.999 L8,32 L0,32 L0,-1.77635684e-15 L34,-1.77635684e-15 L34,32 L26,32 Z M8,7.999 L8,23.999 L26,24 L26,8 L8,7.999 Z",
  fillRule: "evenodd"
}) : /*#__PURE__*/React$1.createElement("path", {
  d: "M8 24v8H0v-8h8zm12 0v8h-8v-8h8zm12 0v8h-8v-8h8zM8 12v8H0v-8h8zm12 0v8h-8v-8h8zm12 0v8h-8v-8h8zM8 0v8H0V0h8zm12 0v8h-8V0h8zm12 0v8h-8V0h8z",
  fillRule: "evenodd"
}))), !isOverview && /*#__PURE__*/React$1.createElement(React$1.Fragment, null, currentCaption && /*#__PURE__*/React$1.createElement(Typography$1, {
  className: "controls__caption"
}, currentCaption), /*#__PURE__*/React$1.createElement("div", {
  className: "controls__bullets"
}, Array.from(Array(numberOfBullets).keys()).map(item => /*#__PURE__*/React$1.createElement("button", {
  key: item,
  type: "button",
  onClick: () => handleChange(item),
  "aria-label": `Go to slide ${item + 1}`
}, /*#__PURE__*/React$1.createElement("span", {
  className: currentIndex === item ? 'is-active' : ''
})))))), /*#__PURE__*/React$1.createElement("div", {
  className: "controls__header"
}, /*#__PURE__*/React$1.createElement("button", {
  type: "button",
  onClick: handleClose,
  className: "controls__close",
  "aria-label": "Close Gallery"
}, "Close", /*#__PURE__*/React$1.createElement(CssIcon, {
  icon: "close"
}))));

Controls.propTypes = {
  handleNext: PropTypes$1.func.isRequired,
  handlePrevious: PropTypes$1.func.isRequired,
  handleOverview: PropTypes$1.func.isRequired,
  handleClose: PropTypes$1.func.isRequired,
  handleChange: PropTypes$1.func.isRequired,
  numberOfBullets: PropTypes$1.number.isRequired,
  currentIndex: PropTypes$1.number.isRequired,
  isOverview: PropTypes$1.bool.isRequired,
  currentCaption: PropTypes$1.string
};
Controls.defaultProps = {
  currentCaption: null
};

export default Controls;
